import { setContext } from "@apollo/client/link/context";
import userPreferencesStorage from "src/modules/preferences/storage";
const addLangHeaderLink = setContext((_, context) => {
    const lang = userPreferencesStorage.getPrefs().lang;
    if (!lang) {
        return context;
    }
    return {
        ...context,
        headers: {
            ...context.headers,
            'accept-language': lang,
        },
    };
});
export default addLangHeaderLink;
